// extracted by mini-css-extract-plugin
export default {"formGroup":"Input_formGroup__MEi4o","mandatory":"Input_mandatory__SyS2E"};